"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalModel = void 0;
var mobx_1 = require("mobx");
var ModalModel = /** @class */ (function () {
    function ModalModel(service) {
        var _this = this;
        this.type = "default";
        this.disableBackdrop = false;
        this.pending = 0;
        this.showClose = true;
        this.footerClassName = "";
        this.title = "";
        this.className = "";
        this.componentProps = null;
        this.actions = [];
        this.content = null;
        this.visible = false;
        this.animationOptions = {
            animateIn: "fadeIn",
            animateOut: "fadeOut",
            speed: 6,
            delay: 0
        };
        this.backdropAnimateIn = "fadeIn";
        this.backdropAnimateOut = "fadeOut";
        this._animationClass = this.animationOptions.animateIn;
        this.animateInFn = function () {
            _this._animationClass = _this.animationOptions.animateIn;
        };
        this.animateOutFn = function () {
            _this._animationClass = _this.animationOptions.animateOut;
        };
        this.service = service || null;
    }
    ModalModel.prototype.onAction = function (action, service, model) {
        throw new Error("Method not implemented.");
    };
    Object.defineProperty(ModalModel.prototype, "animationClass", {
        get: function () {
            return "animated ".concat(this._animationClass, " delay-").concat(this.animationOptions.delay, " speed-").concat(this.animationOptions.speed);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ModalModel.prototype, "isLoading", {
        get: function () {
            return this.pending > 0;
        },
        enumerable: false,
        configurable: true
    });
    ModalModel.prototype.set = function (config, res, rej) {
        this.content = config.content || null;
        this.actions = config.actions || [];
        this.componentProps = config.componentProps || null;
        this.className = config.className || "";
        this.showClose = typeof config.showClose !== "undefined" ? config.showClose : this.showClose;
        this.title = config.title || "";
        this.userOnClose = config.onClose;
        this.res = res;
        this.footerClassName = config.footerClassName || "";
        this.rej = rej;
        this.visible = true;
        this.animationOptions = __assign(__assign({}, this.animationOptions), config.animationOptions);
        if (config.animationOptions) {
            this._animationClass = config.animationOptions.animateIn || this.animationOptions.animateIn;
        }
    };
    ModalModel.prototype.onClose = function () {
        this.service && this.service.hide();
        if (this.userOnClose) {
            this.userOnClose();
        }
        else if (this.rej) {
            this.rej(null);
        }
    };
    __decorate([
        mobx_1.observable
    ], ModalModel.prototype, "type", void 0);
    __decorate([
        mobx_1.observable
    ], ModalModel.prototype, "disableBackdrop", void 0);
    __decorate([
        mobx_1.observable
    ], ModalModel.prototype, "pending", void 0);
    __decorate([
        mobx_1.observable
    ], ModalModel.prototype, "showClose", void 0);
    __decorate([
        mobx_1.observable
    ], ModalModel.prototype, "footerClassName", void 0);
    __decorate([
        mobx_1.observable
    ], ModalModel.prototype, "title", void 0);
    __decorate([
        mobx_1.observable
    ], ModalModel.prototype, "className", void 0);
    __decorate([
        mobx_1.observable
    ], ModalModel.prototype, "componentProps", void 0);
    __decorate([
        mobx_1.observable
    ], ModalModel.prototype, "actions", void 0);
    __decorate([
        mobx_1.observable
    ], ModalModel.prototype, "content", void 0);
    __decorate([
        mobx_1.observable
    ], ModalModel.prototype, "visible", void 0);
    __decorate([
        mobx_1.observable
    ], ModalModel.prototype, "animationOptions", void 0);
    __decorate([
        mobx_1.observable
    ], ModalModel.prototype, "_animationClass", void 0);
    __decorate([
        mobx_1.computed
    ], ModalModel.prototype, "animationClass", null);
    __decorate([
        mobx_1.computed
    ], ModalModel.prototype, "isLoading", null);
    __decorate([
        mobx_1.action.bound
    ], ModalModel.prototype, "set", null);
    __decorate([
        mobx_1.action.bound
    ], ModalModel.prototype, "animateInFn", void 0);
    __decorate([
        mobx_1.action.bound
    ], ModalModel.prototype, "animateOutFn", void 0);
    __decorate([
        mobx_1.action.bound
    ], ModalModel.prototype, "onClose", null);
    return ModalModel;
}());
exports.ModalModel = ModalModel;
